/// <amd-module name="Release/Landing/LeftPanel/ActivePipelines/ActivePipelineRow" />
import * as React from "react";
import { css } from "VSSUI/Util";
import { Tooltip } from "VSSUI/TooltipEx";

import { Favorite } from "Favorites/Common/Contracts/Favorite";

import { ActivePipelineFavoritesStar } from "Release/Landing/LeftPanel/ActivePipelines/ActivePipelineFavoritesStar";
import { ActivePipelinePanelItemText } from "Release/Landing/LeftPanel/ActivePipelines/ActivePipelinePanelItemText";
import { Deployment, ReleaseApproval } from "Release/Client/Contracts/Release";
import * as Resources from "Release/Landing/Resources";

import { VssComponent, IVssComponentProperties, IVssComponentContext } from "VSS/Platform/Layout";
import { ago } from "VSSUI/Utilities/Date";
import { announce } from "VSS/Core/Util/Accessibility";
import { localeFormat } from "VSS/Core/Util/String";

import { StoreManager } from "DistributedTask/Flux/StoreManager";
import { SelectionStore } from "Selection/SelectionStore";

import "VSS/LoaderPlugins/Css!Release/Landing/ActivePipelineRow";

export interface IActivePipelineRowProps extends IVssComponentProperties {
    definitionId: number;
    name: string;
    pendingApproval: ReleaseApproval | null | undefined;
    lastDeployment: Deployment | null | undefined;
    onClick: () => void;
    isSearched: boolean;
}

export class ActivePipelineRow extends VssComponent<IActivePipelineRowProps, {}>{
    public render(): React.ReactNode {
        const isSelected = StoreManager.GetStore<SelectionStore>(SelectionStore).getState().id === this.props.definitionId;

        const onClick = (event: React.SyntheticEvent<HTMLElement>) => {
            const eventTarget = event.nativeEvent.target as HTMLElement;
            if (eventTarget && !eventTarget.classList.contains("vss-FavoriteItem--starIcon") && ["a", "button"].indexOf(eventTarget.tagName.toLowerCase()) < 0) {
                this.props.onClick();
            }
        };

        return (
            <div
                data-is-focusable
                className={css("act-rel-pipe-row cursor-pointer", this.props.className, isSelected && "selected")}
                aria-label={this.props.name}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                    onClick(event);
                }}
                onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) =>
                    (event.key === "" || event.key === "Spacebar" || event.key === "Enter") && onClick(event)
                }
            >
                <div className={"flex-row"}>
                    <div className={"row-content overflow-ellipsis"}>
                        <div className="flex">
                            <Tooltip text={this.props.name} overflowOnly={true}>
                                <div className="pipe-name overflow-ellipsis">
                                    {this.props.name}
                                </div>
                            </Tooltip>
                        </div>
                        {
                            !this.props.isSearched &&
                            <div className={"pipe-subtext"}>
                                <ActivePipelinePanelItemText
                                    pendingApproval={this.props.pendingApproval as any}
                                    lastDeployment={this.props.lastDeployment as any}
                                    pendingApprovalDate={this.props.pendingApproval && this.props.pendingApproval.createdOn ? ago(this.props.pendingApproval.createdOn) : ""}
                                    pageContext={this.context.pageContext}
                                />
                            </div>
                        }
                    </div>

                    <ActivePipelineFavoritesStar
                        key={"favorite-" + this.props.definitionId}
                        className={"active-pipeline-favorite"}
                        definitionId={this.props.definitionId}
                        definitionName={this.props.name}
                        pageContext={this.context.pageContext}
                        onAddFavorite={(favorite: Favorite) => this._onAddRemoveFavorite(favorite, Resources.PipelineFavoritedAnnounceMessage)}
                        onRemoveFavorite={(favorite: Favorite) => this._onAddRemoveFavorite(favorite, Resources.PipelineUnfavoritedAnnounceMessage)} />
                </div>

            </ div>);
    }

    private _onAddRemoveFavorite = (favorite: Favorite, message: string) => {
        const announceMessage = localeFormat(message, favorite.artifactName);
        announce(announceMessage);
    }
}
